const doc = [({"en":({"js":({"shared":({"amount_of_months":"%{amount} months", "dismiss":"Dismiss", "error":"Error"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;